import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core'
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatTooltipModule } from '@angular/material/tooltip'
import { LayersClonedService } from '@core/services/layers-cloned.service'

@Component({
  selector: 'app-dialog-clone-repository',
  templateUrl: './dialog-clone-repository.component.html',
  styleUrl: './dialog-clone-repository.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    // Forms
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,

    // Material
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
  ],
})
export class DialogCloneRepositoryComponent {
  readonly dialogRef = inject(MatDialogRef<DialogCloneRepositoryComponent>)
  private readonly _layersClonedService = inject(LayersClonedService)
  data = inject(MAT_DIALOG_DATA)

  isLoading$ = signal<boolean>(false)

  cloneRepoForm = new FormGroup({
    repoURL: new FormControl<string>('', [Validators.required]),
  })

  constructor() {}

  async submitFormCloneRepo() {
    const repoURL = this.cloneRepoForm.get('repoURL')?.value

    if (!this.cloneRepoForm.valid || !repoURL) {
      return
    }

    this.isLoading$.set(true)
    try {
      await this._layersClonedService.cloneRepository(repoURL)
      this.dialogRef.close(true)
    } finally {
      this.isLoading$.set(false)
    }
  }
}
